<template>
  <div style="background: #fff;height: 100%">
    <div>
      <div class="title1">企业信息添加</div>
    </div>
    <div>
      <div class="uploadImgWrapper flex borderT">
        <div class="title">营业执照<span class="redTip">*</span></div>
        <div class="uploadImgBox">
          <uploadImg v-model="params.businessLicenseUrl"></uploadImg>
          <div v-if="params.businessLicenseUrl">
            <img :src="params.businessLicenseUrl" />
          </div>
          <div v-else>
            <img src="../../assets/xiangji.png" />
          </div>
        </div>
      </div>
      <div class="lineBox flex">
        <div class="title">公司名称</div>
        <div class="flex1">
          <input
            class="lineInput"
            @focus="init1()"
            @blur="getEcho1"
            v-model="params.companyName"
            placeholder="请输入公司名称"
          />
        </div>
      </div>
      <div class="lineBox flex">
        <div class="title">营业执照号</div>
        <div class="flex1">
          <input
            class="lineInput"
            v-model="params.companyCode"
            @focus="init2()"
            @blur="getEcho2"
            placeholder="请输入营业执照号"
          />
        </div>
      </div>
      <div class="lineBox flex">
        <div class="title">注册地址</div>
        <div class="flex1">
          <input
            class="lineInput"
            placeholder="请输入注册地址"
            v-model="params.registeredAddress"
          />
        </div>
      </div>
    </div>
    <div class="addButton" @click="nextStep">下一步</div>
  </div>
</template>

<script scoped>
import uploadImg from "@/components/uploadImg/uploadImg";
import { getEcho } from "../../api/identify";
export default {
  components: {
    uploadImg
  },
  data() {
    return {
      params: {
        businessLicenseUrl: "",
        companyCode: "",
        companyName: "",
        registeredAddress: ""
      },
      initCompanyName: "",
      initCompanyCode: ""
    };
  },
  methods: {
    init1() {
      this.initCompanyName = this.params.companyName;
    },
    init2() {
      this.initCompanyCode = this.params.companyCode;
    },
    getEcho1() {
      if (this.params.companyName != this.initCompanyName) {
        this.$vux.loading.show();
        getEcho({ companyName: this.params.companyName })
          .then(res => {
            if (res) {
              this.params.companyName = res.companyName;
              this.params.companyCode = res.companyCode;
            }
            this.$vux.loading.hide();
          })
          .catch(err => {
            this.$showError(err);
            this.$vux.loading.hide();
          });
      }
    },
    getEcho2() {
      if (this.params.companyCode != this.initCompanyCode) {
        this.$vux.loading.show();
        getEcho({ companyCode: this.params.companyCode })
          .then(res => {
            if (res) {
              this.params.companyName = res.companyName;
              this.params.companyCode = res.companyCode;
            }
            this.$vux.loading.hide();
          })
          .catch(err => {
            this.$showError(err);
            this.$vux.loading.hide();
          });
      }
    },
    nextStep() {
      if (!this.params.businessLicenseUrl) {
        this.$showError("请上传营业执照");
      } else if (!this.params.companyName) {
        this.$showError("请输入公司名称");
      } else if (!this.params.companyCode) {
        this.$showError("请输入营业执照号");
      } else {
        this.$ls.set("companyInfo", this.params);
        this.$router.push({ path: "/identify/legalPersonIdentify" });
      }
    }
  }
};
</script>

<style lang="less" scoped>
.redTip {
  color: red;
}
.protocol-text {
  display: inline;
}
input {
  width: 100%;
  border: none;
  background: #fff;
}
.flex {
  display: flex;
}
.flex1 {
  flex: 1;
}
.protocol-text {
  display: inline;
}
.inputWapper {
  align-items: center;
  margin: 30px 60px 0 60px;
  border-bottom: 1px solid #e2e2e2;
  padding-bottom: 12px;
  overflow: hidden;
  &.protocol {
    border: none;
    font-size: 12px;
    color: #bfbfbf;
    .protocol-link {
      font-size: 11px;
      color: #007bec;
    }
  }
}
.title1 {
  text-align: center;
  font-size: 20px;
  line-height: 40px;
  padding: 90px 0 40px 0;
  font-weight: bold;
}
.title2 {
  text-align: center;
  font-size: 15px;
  line-height: 30px;
  padding-bottom: 90px;
}
.borderT {
  border-top: 1px solid #e8e8e8;
}
.lineBox {
  margin: 0 50px;
  height: 50px;
  line-height: 50px;
  padding: 24px 16px;
  border-bottom: 1px solid #e8e8e8;
}
.title {
  font-size: 15px;
}
.lineInput {
  height: 50px;
  line-height: 50px;
  text-align: right;
  color: #474747;
  font-size: 14px;
}
.codeButton {
  width: 160px;
  height: 50px;
  line-height: 50px;
  text-align: right;
  font-size: 14px;
  border-left: 1px solid #e8e8e8;
  color: #1573ff;
  margin-left: 20px;
}
.addButton {
  margin: 100px 50px 0;
  text-align: center;
  font-size: 16px;
  height: 88px;
  line-height: 88px;
  background: #007bec;
  color: #fff;
  border-radius: 10px;
}

.searchBox {
  font-size: 14px;
  padding: 40px;
  height: 64px;
  line-height: 64px;
}
.searchInput {
  height: 64px;
  line-height: 64px;
  border: 1px solid #d9d9d9;
  border-radius: 8px;
  padding: 0 20px;
  margin-right: 20px;
}
uni-picker-view {
  display: block;
}

uni-picker-view .uni-picker-view-wrapper {
  display: flex;
  position: relative;
  overflow: hidden;
  height: 100%;
  background-color: white;
}

uni-picker-view[hidden] {
  display: none;
}

picker-view {
  width: 100%;
  height: 600px;
  margin-top: 20px;
}
.item {
  line-height: 100px;
  font-size: 16px;
  text-align: center;
}
.uni-padding-wrap {
  padding: 40px;
  font-size: 16px;
}
.uploadImgWrapper {
  margin: 0 50px;
  padding: 24px 16px;
  border-bottom: 1px solid #e8e8e8;
  overflow: hidden;
}
.uploadImgBox {
  position: relative;
  width: 200px;
  height: 200px;
  overflow: hidden;
  margin-left: 60px;
}
.uploadImgBox img {
  width: 100%;
  height: 100%;
}
</style>
